import TemplatesServices from "../../services/templatesServices";
import {
  attemptSetFolder,
  setFolderSuccess,
  attemptGetTemplates,
  getTemplatesSuccess,
  attemptSetTemplate,
  setTemplateSuccess,
  setActiveFolderId,
  attemptEditFolder,
  editFolderSuccess,
  attemptRemoveFolder,
  removeFolderSuccess,
  removeFolderFail,
} from "../actions/templatesActions";

const templatesServices = new TemplatesServices();

const getInitialActiveFolderId = (folders) => {
  if (!folders.length) return null;
  const first = folders[0];
  if (first.templateCount > 0) return first.id;
  if (first.children?.length > 0) return first.children[0].id;
  return first.id;
};

export const getFolders = async (showInModal, sortQuery, search) => {
  const foldersRes = await templatesServices.getFolders();
  const folders = foldersRes.data.data;
  if (showInModal) {
    return { folders, activeFolderId: null };
  }
  const currentPath = window.location.pathname.split("/").pop();
  const activeFolderId =
    currentPath === "templates" ? getInitialActiveFolderId(folders) : Number(currentPath);
  const result = { folders, activeFolderId, templates: null };
  if (search) {
    const tmpltsRes = await templatesServices.getTemplates(null, sortQuery, search);
    result.templates = tmpltsRes.data.data;
    const matchingFolderIds = new Set(result.templates.map((t) => t.folderId));
    result.folders = folders
      .map((folder) => {
        const hasMatch = matchingFolderIds.has(folder.id);
        const filteredChildren = (folder.children || []).filter((child) =>
          matchingFolderIds.has(child.id),
        );
        if (hasMatch || filteredChildren.length) {
          return { ...folder, children: filteredChildren };
        }
        return null;
      })
      .filter(Boolean);
  } else if (activeFolderId) {
    const tmpltsRes = await templatesServices.getTemplates(activeFolderId, sortQuery);
    result.templates = tmpltsRes.data.data;
  }
  return result;
};

export const setFolder = async (name, dispatch, navigate, props, parentId) => {
  try {
    dispatch(attemptSetFolder());
    const response = await templatesServices.setFolder(name, parentId);
    const res = response.data;
    if (!parentId && !props.showInModal) {
      navigate(`/templates/${res.id}`);
    }
    dispatch(setFolderSuccess(res));
  } catch (e) {}
};

export const editFolder = async ({ folderId, folderName }, list, dispatch, setIndex) => {
  try {
    dispatch(attemptEditFolder());
    await templatesServices.editFolder({ folderId, folderName });
    const updatedList = list.map((folder) => {
      if (folderId === folder.id) {
        return { ...folder, name: folderName };
      }
      if (folder.children) {
        return {
          ...folder,
          children: folder.children.map((child) =>
            child.id === folderId ? { ...child, name: folderName } : child,
          ),
        };
      }
      return folder;
    });
    setIndex(0);
    dispatch(editFolderSuccess(updatedList));
  } catch (e) {}
};

export const removeFolder = async (id, dispatch, navigate, folder) => {
  try {
    dispatch(attemptRemoveFolder());
    await templatesServices.removeFolder(id);
    const isRootFolder = folder.list.some((f) => f.id === id);
    let filteredList;
    if (isRootFolder) {
      filteredList = folder.list.filter((f) => f.id !== id);
    } else {
      filteredList = folder.list.map((f) =>
        f.children ? { ...f, children: f.children.filter((child) => child.id !== id) } : f,
      );
    }
    if (folder.activeFolderId === id) {
      navigate("/templates");
      dispatch(removeFolderSuccess({ id: null, filteredList }));
    } else {
      navigate(`/templates/${folder.activeFolderId}`);
      dispatch(removeFolderSuccess({ id: folder.activeFolderId, filteredList }));
    }
  } catch (e) {
    dispatch(removeFolderFail());
  }
};

export const setTemplate = async (data, dispatch) => {
  try {
    dispatch(attemptSetTemplate());
    const response = await templatesServices.setTemplate(data);
    const res = response.data;
    dispatch(setTemplateSuccess(res));
    return res;
  } catch (e) {}
};

export const getTemplates = async (
  id,
  dispatch,
  navigate,
  setShowSpinner,
  showInModal,
  sort,
  search,
) => {
  try {
    if (id) {
      dispatch(attemptGetTemplates());
      setShowSpinner(true);
      const tmpltsRes = await templatesServices.getTemplates(id, sort, search);
      const templates = tmpltsRes.data.data;
      !showInModal && navigate(`/templates/${id}`);
      dispatch(getTemplatesSuccess({ templates, id }));
      setShowSpinner(false);
    } else {
      !showInModal && navigate(`/templates`);
      dispatch(setActiveFolderId(id));
    }
  } catch (e) {}
};

export const getPreviewData = async (id) => {
  const response = await templatesServices.getPreviewData(id);
  return response.data;
};
